module.exports = __webpack_public_path__ + "img/9648868_orig.5a967131.png";